<section class="list-container">
  <div *ngFor="let section of sections" class="list">
    <h2>{{ section.title | translate }}</h2>
    <div *ngFor="let item of section.list" class="list-item">
      <p class="item-name">{{ item.name | translate }}</p>
      <p class="item-value">{{ item.value | translate }}</p>
    </div>
  </div>
</section>
